
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from "@/components/ui/card";

export interface ComplianceReport {
  id: string;
  name: string;
  frequency: string;
  applicable: boolean;
  type: string;
}

interface ReportTableProps {
  reports: ComplianceReport[];
  searchTerm: string;
}

const ReportTable: React.FC<ReportTableProps> = ({ reports, searchTerm }) => {
  return (
    <Card>
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b bg-muted/50">
                <th className="text-left p-4">Report Name</th>
                <th className="text-left p-4">Filing Frequency</th>
                <th className="text-left p-4">Applicable</th>
              </tr>
            </thead>
            <tbody>
              {reports.map((report) => (
                <tr 
                  key={report.id} 
                  className="border-b hover:bg-muted/50 cursor-pointer"
                >
                  <td className="p-4 font-medium">
                    <Link 
                      to={`/compliance/reports/${report.id}`} 
                      className="hover:underline"
                    >
                      {report.name}
                    </Link>
                  </td>
                  <td className="p-4">{report.frequency}</td>
                  <td className="p-4">{report.applicable ? 'Yes' : 'No'}</td>
                </tr>
              ))}
              {reports.length === 0 && (
                <tr>
                  <td colSpan={3} className="p-4 text-center text-muted-foreground">
                    No reports found matching your search{searchTerm ? `: "${searchTerm}"` : '.'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};

export default ReportTable;
